import { render, staticRenderFns } from "./ContactsBanner.vue?vue&type=template&id=1ec84fb2&scoped=true&"
import script from "./ContactsBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContactsBanner.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ContactsBanner.vue?vue&type=style&index=0&id=1ec84fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec84fb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec84fb2')) {
      api.createRecord('1ec84fb2', component.options)
    } else {
      api.reload('1ec84fb2', component.options)
    }
    module.hot.accept("./ContactsBanner.vue?vue&type=template&id=1ec84fb2&scoped=true&", function () {
      api.rerender('1ec84fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsBanner.vue"
export default component.exports